/**
 * 登录态的展示缓存。
 *
 * 导航栏的用户名靠 mounted() 里的 user-info 接口填，而这个请求要跨域打
 * api.cutterman.cn，服务端又把 Access-Control-Max-Age 设成 0，所以每次调用都要先发
 * 一次 OPTIONS 预检 —— 实测从进页面到拿到登录态要 350~900ms。预渲染出来的 HTML 里
 * 导航栏永远是未登录版本（预渲染时当然没登录），于是每次刷新、每次翻页都会先闪一下
 * 「LOGIN」再变成用户名，看起来就像登录态时有时无。
 *
 * 这里把用户名和头像存一份在本地，导航栏首屏直接用它渲染，接口回来后再校正。
 * 只是展示用的缓存：任何真实操作（下单、进个人中心）仍然以服务端的鉴权结果为准，
 * 服务端一旦明确说未登录（HTTP 401 或 errno 12）就立刻清掉。
 */
const KEY = 'mirror-user'

export function readUserCache() {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    // 没有 token 就谈不上登录，缓存作废
    if (!localStorage.getItem('access_token')) return null
    const u = JSON.parse(raw)
    return u && u.name ? u : null
  } catch (e) {
    return null
  }
}

export function writeUserCache(user) {
  try {
    localStorage.setItem(KEY, JSON.stringify({
      name: user.name, avatar: user.avatar, email: user.email
    }))
  } catch (e) {}
}

export function clearUserCache() {
  try {
    localStorage.removeItem(KEY)
  } catch (e) {}
}
